import { useRef, useEffect } from "react";
import { TOUR_TARGETS } from "../../constants/tourTargets";

const tabbarClasses =
  "sticky top-0 z-10 bg-primary-surface border-b border-border-light " +
  "-mx-6 mb-5 mt-0 p-0";

const scrollClasses =
  "demand-studio-tabbar-scroll flex overflow-x-auto " +
  "[scrollbar-width:thin] [scrollbar-color:var(--color-border)_transparent]";

const tabBase =
  "shrink-0 inline-flex items-center gap-1.5 py-2.5 px-4 " +
  "font-action-sans text-[calc(var(--spacing)*3.25)] font-medium text-subtle " +
  "bg-transparent border-0 border-b-2 border-b-transparent " +
  "border-r border-r-border-light last:border-r-0 " +
  "cursor-pointer whitespace-nowrap max-w-50 " +
  "transition-[color,background,border-color] duration-[120ms] " +
  "hover:text-label hover:bg-primary/[0.04]";

const tabActive = "text-primary font-semibold bg-white border-b-primary";

const tabLabelClasses = "overflow-hidden text-ellipsis";

const DemandStudioTabBar = ({ tabs, activeTabType, onTabClick, containerRef }) => {
  const activeTabRef = useRef(null);

  useEffect(() => {
    activeTabRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
  }, [activeTabType]);

  return (
    <div ref={containerRef} className={tabbarClasses} data-tour={TOUR_TARGETS.DEMAND_STUDIO_TABS}>
      <div className={scrollClasses}>
        {tabs.map((tab) => {
          const isActive = tab.type === activeTabType;
          return (
            <button
              key={tab.type}
              ref={isActive ? activeTabRef : null}
              type="button"
              className={`${tabBase} ${isActive ? tabActive : ""}`}
              onClick={() => onTabClick(tab.type)}
              title={tab.label}
              aria-pressed={isActive}
            >
              <span className={tabLabelClasses}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DemandStudioTabBar;
